import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service'
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../../services/config/config.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  idp: string = environment.identityProvider;
  authorized = true;
  fnolRole = [ environment.authRoles.fnolWallboard, environment.authRoles.fnolConfig];
  healthRole = [ environment.authRoles.healthWallboard, environment.authRoles.healthConfig];
  lifeRole = [ environment.authRoles.lifeConfig, environment.authRoles.lifeWallboard];
  claimsRole = [ environment.authRoles.claimsConfig, environment.authRoles.claimsWallboard];
  hrRole = [environment.authRoles.hrConfig, environment.authRoles.hrWallboard];
  pncRole = [environment.authRoles.pncConfig, environment.authRoles.pncWallboard];
  insidesalesRole = [environment.authRoles.insidesalesConfig, environment.authRoles.insidesalesWallboard];
  itRole = [environment.authRoles.itConfig, environment.authRoles.itWallboard];
  aaccRole = [environment.authRoles.aaccConfig, environment.authRoles.aaccWallboard];
  memberOf = this.auth.memberOf;

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService,
    private configService: ConfigService
  ) { }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('authorized') === 'false') {
      this.authorized = false;
    }
    console.log("ROLES: ", this.memberOf);

    this.configService.activeLOB = null;
  }

  //modify function to grant all access if telecom in memberOf? or unnecessary?
  authorizedFor(roles: string[]) {
    let authorized: boolean;
    roles.map((role: string) => {
      if (this.memberOf.includes(role) || this.auth.memberOf.includes(environment.roles.telecom)) {
        authorized = true;
      }
    })
    return authorized;
  }
}
